import React, { useContext } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { HISContext } from '../Context/HISContext';
import { StyledBatchDownloadButton } from '../../components/layout/WrapperDiv';
import defaults from '../../translations/en.json';

export const BatchDownloadButton = () => {
  const {
    palette: { primary },
  } = useTheme() as any;
  const { DownloadUnsentXML } = useContext(HISContext);

  // styles defined here to override MUI css
  return (
    <StyledBatchDownloadButton
      style={{
        color: primary.contrastText,
        backgroundColor: primary.main,
        fontSize: '10px',
        height: '1.25em',
        fontWeight: 'bold',
      }}
      onClick={DownloadUnsentXML}
    >
      {`${defaults.batchDownload}`}
    </StyledBatchDownloadButton>
  );
};
